import React, { useState } from "react";
import { CustomAccordion } from "../components";
import { RegionChartSingleYear, CountryChartSingleYear, BusinessUnitChartSingleYear, SiteTypeChartSingleYear } from "../../charts";
import { DropdownProps } from "../types";

const SingleYearByScopeDropdown = ({ searchFilters, subTypeChart, currentMainTab, fiscalYears }: DropdownProps) => {
  const [currentFiscalYear, setCurrentFiscalYear] = useState<string>(`${new Date().getFullYear()}`);

  return <CustomAccordion
    titleAccordion="Single Year by Scope"
    currentFiscalYear={currentFiscalYear}
    setCurrentFiscalYear={setCurrentFiscalYear}
    allFiscalYears={fiscalYears}
    panelNumber={3}
    allowFiscalYears
  >
    <RegionChartSingleYear
      chartTitle="Region"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      currentFiscalYear={currentFiscalYear}
    />
    <CountryChartSingleYear
      chartTitle="Country"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      currentFiscalYear={currentFiscalYear}
    />
    <BusinessUnitChartSingleYear
      chartTitle="Business Unit"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      currentFiscalYear={currentFiscalYear}
    />
    <SiteTypeChartSingleYear
      chartTitle="Site Type"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      currentFiscalYear={currentFiscalYear}
    />
  </CustomAccordion>
}

export default SingleYearByScopeDropdown;